module.exports = __webpack_public_path__ + "8455ab876cdcc25916ab641a4fdbd309.svg";